// OIDC sign-in screen — shown for /login when REACT_APP_AUTH_MODE=oidc. Unlike the
// dummy picker there is no participant list; a single action redirects to the PCS IdP,
// which returns to /auth/callback (AuthCallback). Built in the same design language as
// the dummy Login (reuses login.css), so no new CSS/tokens are introduced.
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Surface, Spinner } from '../../components/reusable';
import { useAuth } from '../AuthProvider';
import { SparkleIcon } from '../../components/icons/Icons';
import { signinRedirect } from './userManager';
import '../../pages/Login/login.css';

export function OidcLogin() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  // Carry the intended destination through the IdP round-trip (returned via user.state).
  const redirectTo = location.state?.from?.pathname || '/';
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  // Already signed in (e.g. navigated here manually) → go to the app.
  if (isAuthenticated) return <Navigate to={redirectTo} replace />;

  const handleSignIn = async () => {
    setBusy(true);
    setError(null);
    try {
      await signinRedirect({ state: { returnTo: redirectTo } });
    } catch (err) {
      setError(err.message || 'Could not start sign-in. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <Surface className="login-card" padding="none">
        <div className="login-brand">
          <span className="login-brand__mark"><SparkleIcon width={18} height={18} /></span>
          <span className="login-brand__name">PCS Retirement</span>
        </div>
        <h1 className="login-title">Welcome</h1>
        <p className="login-sub">Sign in with your PCS Retirement account to continue.</p>

        {error && <div className="login-error" role="alert">{error}</div>}

        <ul className="login-list">
          <li>
            <button
              type="button"
              className="login-user"
              onClick={handleSignIn}
              disabled={busy}
              aria-busy={busy}
            >
              <span className="login-user__text">
                <span className="login-user__name">Sign in with PCS Retirement</span>
                <span className="login-user__meta">Single sign-on via the PCS Identity Provider</span>
              </span>
              {busy
                ? <Spinner size="sm" />
                : <span className="login-user__arrow" aria-hidden="true">→</span>}
            </button>
          </li>
        </ul>

        <p className="login-note">You'll be redirected to the PCS Identity Provider to sign in.</p>
      </Surface>
    </div>
  );
}

export default OidcLogin;
